import { render, staticRenderFns } from "./Ventanas.vue?vue&type=template&id=27d77b63&"
import script from "./Ventanas.vue?vue&type=script&lang=js&"
export * from "./Ventanas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports